<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Announcements
                  </h2>
                  <hr
                    class="divider m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>

                <!--
                <div class="col-12">
                  <p>
                    At this time there are no annoucements yet.
                  </p>
                </div>
                -->

                <!--
                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    October 19, 2021
                  </h4>
                  <p>
                    Website was launched.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>
                -->

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 29, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 15:00 PM in Zurich Enge, Birmensdorf, Bonstetten, und Aeugst am Albis.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 28, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 15:00 PM in Zurich around Seebecken, Enge, Wiedikon, and Albisrieden.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 27, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 11:00 AM and 13:00 PM in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 26, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 11:00 AM and 13:00 PM around Zumikon and Egg.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 23, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 15:00 PM in Zurich around Hirslanden, Hottingen, und Fluntern.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 15, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 12:00 PM and 15:00 PM around Zollikerberg, Zumikon, and Forch.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 14, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 15:00 PM in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 12, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 11:00 AM and 14:00 PM in Zurich around Uetliberg, Hoengg, Wipkingen, Unterstrass, Zurichberg, and in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    June 8, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 10:00 AM and 13:00 PM in Zurich around Uetliberg, Hoengg, Wipkingen, Unterstrass, Zurichberg, and in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    May 16, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 19:00 PM and 21:00 PM in Zurich around Hirslanden, Hottingen, und Fluntern.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    May 15, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 16:00 PM in Zurich around Langstrasse, Sihlfeld, und Altstetten.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    April 21, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 15:00 PM around Zumikon and Egg.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    March 20, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 19:00 PM and 21:00 PM in Zurich around Seebecken, Enge, Wiedikon, and Albisrieden.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    March 20, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:00 PM and 16:00 PM in Zurich around Hauptbahnhof, Letten, Wipkingen, Milchbuck, and Hoengg.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    March 17, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 12:00 PM and 15:00 PM in Zurich around Milchbuck, Hoengg, and Wipkingen.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    February 14, 2023
                  </h4>
                  <p>
                    We will record a data sample on that day between 07:00 AM and 14:00 PM in Zurich around Uetliberg, Hoengg, Wipkingen, Unterstrass, Zurichberg, and in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 16, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 09:00 AM and 11:00 AM in Zurich around Milchbuck, Hoengg, and Wipkingen.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 15, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 16:00 PM and 18:00 PM around Uetliberg and in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 15, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 09:00 AM and 12:00 PM in Affoltern am Albis, Zug, and Menzingen.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 14, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 14:00 PM and 16:00 PM in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 13, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 17:30 PM and 19:00 PM around Zumikon and Egg.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 9, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 10:00 AM and 12:00 PM around Zollikerberg, Zumikon, and Forch.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 7, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 07:30 AM and 09:00 AM around Uetliberg and the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 6, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 07:30 AM and 09:00 AM around Kloten, Wallisellen, and Dubendorf.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    December 1, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 14:00 PM and 16:00 PM in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    November 23, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 17:00 PM and 18:30 PM in the center of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    November 15, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 10:00 AM and 12:30 PM in the area of Zug.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    September 15, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 15:30 PM and 18:00 PM in Kreis 4, 5, 6, and 7 of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    August 19, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 13:30 PM and 16:30 PM in Kreis 6, 11, and 12 of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

                <div class="col-12">
                  <h4 class="text-black mt-3 mb-1">
                    May 19, 2022
                  </h4>
                  <p>
                    We will record a data sample on that day between 10:30 AM and 12:30 PM in Kreis 6 and 7 of Zurich.
                  </p>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>

              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "AnnouncementsPage.vue",
  components: {
    NavigationMain
  }
};
</script>
